import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconImage20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconImage20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.5 4.5h-13a1 1 0 0 0-1 1v5.325l4.114-2.468.415-.25.398.276 6.154 4.26 3.919-1.742V5.5a1 1 0 0 0-1-1m1 8.043-3.695 1.642-.386.172-.346-.24-6.102-4.225L2.5 12.575V14.5a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1zM3.5 3A2.5 2.5 0 0 0 1 5.5v9A2.5 2.5 0 0 0 3.5 17h13a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 16.5 3zm10.25 6a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 1.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconImage20);
